import OrderingCard from "../components/orderingCard";
import OrderList from "../components/orderList";
import AddOrderButton from "../components/addOrderButton";
import Layout from "../components/layout";
import React, {useEffect, useState} from "react";
import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import {AuthContext} from "../contexts/auth";
import {toast} from "react-toastify";
import {getPaymentMethod} from "../utils/utils";
import {useHistory} from "react-router";

function HomeView() {

    const [state] = React.useContext(AuthContext)
    const [orders, setOrders] = useState([])
    let history = useHistory()

    useEffect(() => {
        const id = toast.loading("Wir laden die neuen Bestellungen für dich")

        axios({
            method: "get",
            url: Endpoints.ORDERS,
            headers: state.auth ? {
                "Authorization": "Bearer " + localStorage.getItem("token")
            } : {}
        }).then(res => {
            setOrders(res.data || [])
            toast.update(id, {
                render: "Alle Bestellungen geladen",
                type: "success",
                autoClose: 2500,
                isLoading: false,
                closeOnClick: true
            });
        }).catch(err => {
            toast.update(id, {
                render: "Leider ist ein Fehler aufgetreten",
                type: "error",
                autoClose: 2500,
                isLoading: false,
                closeOnClick: true
            });
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }, [state.auth])

    return (
        <Layout>
            <OrderList>
                {
                    orders.map(e => (
                        <OrderingCard
                            key={e.id}
                            id={e.id}
                            calling={e["who_is_calling"]}
                            customer={e["customer"]}
                            ownOrder={e["own_order"]}
                            mayConfirm={e["may_confirm"]}
                            inOrder={e["in_order"]}
                            paymentMethodes={getPaymentMethod(e["payment_methods"])}
                            restaurant={{
                                name: e["restaurant"].name,
                                icon: e["restaurant"].icon,
                            }}
                            timeOfOrdering={e["ordering_for"] + " Uhr"}
                            timeTillOrering={e["accept_until"] + " Uhr"}
                            called={e["called"]}
                            finished={e["finished"]}
                            disabled={e["finished"] || e["called"]}
                        />
                    ))
                }
            </OrderList>
            <AddOrderButton noOrders={orders.length === 0}/>
        </Layout>
    )
}

export default HomeView;